import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ScreenSizeType} from '../enum';

/**
 * Service to control the screen size information.
 */
@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  private currentScreenSize: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  castCurrentScreenSize: any = this.currentScreenSize.asObservable();

  constructor() {
  }

  /**
   * Sets the current screen size
   */
  setScreenSize(size: number): void {
    let deviceType: string;
    if (size <= 640) {
      deviceType = ScreenSizeType.MOBILE;
    } else if (size <= 1024) {
      deviceType = ScreenSizeType.TABLET;
    } else {
      deviceType = ScreenSizeType.DESKTOP;
    }
    this.currentScreenSize.next(deviceType);
  }

  get screenSize(): string {
    return this.currentScreenSize.getValue();
  }

}
